import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { ScrollView, StyleSheet, TextInput } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';

function ThirdConfirmAccountDelete(props) {
  const responsiveFontSize = useResponsiveFontSize(1);
  const getResponsiveFontSize = (factor) => {
    return responsiveFontSize * factor;
  };

  let responsiveStyles = StyleSheet.create({
    secondConfirmFontStyle: {
      fontSize: getResponsiveFontSize(2),
      margin: getResponsiveFontSize(1),
    },
  });

  return (
    <ScrollView style={styles.background}>
      <Text
        style={[responsiveStyles.secondConfirmFontStyle, styles.userSelect]}
      >
        Schreiben Sie
        <Text style={styles.fontBold}> &quot;Löschen&quot; </Text>
        in das Eingabefeld, um die Löschung Ihres Accounts zu bestätigen.
      </Text>
      <TextInput
        allowFontScaling={false}
        autoComplete="off"
        style={styles.inputTextStyle}
        onChangeText={(text) =>
          props?.onUserInput(text?.toLowerCase() === 'löschen')
        }
        placeholder=""
      />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  background: {
    backgroundColor: '#FEFEFE',
  },
  inputTextStyle: {
    backgroundColor: '#F7F7F7',
    fontWeight: '700',
    fontSize: 22,
    height: 50,
    marginLeft: 100,
    marginRight: 100,
    textAlign: 'center',
    color: colors.newUI.therapist.textBlue100,
    borderBottomWidth: 2,
    borderBottomColor: '#A9A9A9', // Darker grey tone for the bottom border
  },
  fontBold: {
    fontWeight: '700',
  },
  userSelect: {
    userSelect: 'none',
  },
});

export default ThirdConfirmAccountDelete;
